export type UserRoles =
  | "ADMIN"
  | "INTERVIEWER"
  | "DONOR"
  | "ACCOUNTANT"
  | "SUPER_ADMIN"
  | "STUDENT"
  | "MENTOR";

export interface UserProps {
  id: number;
  email: string;
  name: string;
  password?: string;
  role: UserRoles;
  donor_contribution_reminder_frequency?: string;
}

export interface UserListProps {
  id: number;
  name: string;
  email: string;
  phone_number: any;
  role: string;
  profile_picture_url: string;
}

export enum UserRolesEnum {
  ADMIN = "ADMIN",
  INTERVIEWER = "INTERVIEWER",
  DONOR = "DONOR",
  ACCOUNTANT = "ACCOUNTANT",
  SUPER_ADMIN = "SUPER_ADMIN",
  STUDENT = "STUDENT",
  MENTOR = "MENTOR"
}

// Donor-specific interfaces
export interface TaggedApplicant {
  id: number;
  name: string;
  email: string;
  role: string;
}

export interface DonorUserResponse {
  id: number;
  name: string;
  email: string;
  phone_number: string | null;
  role: string;
  profile_picture_url: string;
  tagged_applicants: TaggedApplicant[];
  tagged_institutes: string[];
  total_amount_donated: number;
}
